module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"selectAllInstances\" title=\"Select\" style=\"display: none;\">\r\n    <br/>  \r\n\r\n    <div class=\"row\" style=\"padding: 0 0 0 15px; width: 100%; height: auto;\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"toSelect\" id='selectCurrentPage' value='page' checked/>\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n           Current Page\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n            Select all of the records on only the current page.\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" style=\"padding: 0 0 0 15px; width: 100%; height: auto;\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n            <input type=\"radio\" name=\"toSelect\" id='selectAllInstances' value='all'/>\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n            All Pages\r\n        </div>\r\n    </div>\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\"col-md-2\" style=\"width: 20px;\">\r\n        </div>\r\n        <div class=\" col-md-11\">\r\n            Select all of the records on every page.\r\n        </div>\r\n    </div>\r\n   \r\n</div>")
  }
  return __output;

}